let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lRP2A")).then(() => parcelRequire('4Tz5Y'));